window.openMobileMenu = function(icon){
    let parent = $(icon).parent();
    if(parent.hasClass('open-submenu')){
        parent.removeClass('open-submenu');
        parent.find('.open-submenu, .submenu').removeClass(['open-submenu', 'open']);
    } else{
        parent.addClass('open-submenu');
        parent.children('.submenu').addClass('open');
    }
};

window.topMessage = function(){
    $('.header_top-line').hide();
}

window.mobileMenu = function(){
    $('.mobile-menu').toggle();
}

window.legalPersonCheckBox = function(input){
    if($(input).is(':checked')){
        $('.legal_person_fields').show();
    }else{
        $('.legal_person_fields').hide();
    }
}
//onclick mobile show search
window.showSearch = function(el){
    $(el).parent().toggleClass('show-search');
}